import { Field, FieldArray } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { FormFieldWrapper } from '../components/common/FormFieldWrapper';
import './PromoCode.css';
import './ValidatePassNumber.scss';

const ValidatePassNumber = ({
  values,
  actions,
  validateForm,
  validatedPasses,
  errors,
  setFieldValue
}) => {
  const [debouncedCallback] = useDebouncedCallback(() => {
    if (Object.keys(errors).length === 0) {
      actions.getMemberBenefits(values.passNumbers);
    }
  }, 500);

  useEffect(() => {
    if (validatedPasses.length > 0) {
      validateForm();
    }
  }, [validatedPasses]);

  function validatePassNo(value, index) {
    let error;
    if (!value || value === null) {
      error = 'Pass number is required';
    }
    if (validatedPasses.length > 0 && !error) {
      const currentPassObj = validatedPasses.find(
        passObj => passObj.pass_no === value
      );

      if (currentPassObj && currentPassObj.benefitIds.length === 0) {
        error = 'Pass is invalid';
      }
    }
    if (!error) {
      values.passNumbers.some((passObj, idx) => {
        if (
          idx !== index &&
          passObj.pass_no === values.passNumbers[index].pass_no &&
          values.passNumbers[index].pass_no !== undefined
        ) {
          error = 'Pass must be unique';
        }
      });
    }
    return error;
  }

  return (
    <FieldArray
      name="passNumbers"
      render={() => (
        <div className="validate-pass-wrapper">
          <FormFieldWrapper
            name="passNumber"
            label={`Validate pass number${
              values.passNumbers.length > 1 ? 's' : ''
            }`}
            required
            type="text"
          >
            {values.passNumbers.map((_, index) => (
              <React.Fragment key={index}>
                <div className="validate-pass-number-field-and-add-buttons">
                  <Field
                    id={`passNumbers[${index}].pass_no`}
                    name={`passNumbers[${index}].pass_no`}
                    className="swformfield__control validate-pass-number-input"
                    placeholder={`Pass #${index + 1}`}
                    validate={value => validatePassNo(value, index)}
                    onChange={e => {
                      setFieldValue(
                        `passNumbers[${index}].pass_no`,
                        e.target.value.replace(/^\D+/, '')
                      );
                      debouncedCallback();
                    }}
                  />
                </div>
                {!!errors.passNumbers &&
                  !!errors.passNumbers[index] &&
                  !!errors.passNumbers[index].pass_no && (
                    <div className="error-message">
                      {typeof errors.passNumbers[index].pass_no === 'string' &&
                        errors.passNumbers[index].pass_no}
                    </div>
                  )}
              </React.Fragment>
            ))}
          </FormFieldWrapper>
        </div>
      )}
    />
  );
};

ValidatePassNumber.propTypes = {
  values: PropTypes.object,
  actions: PropTypes.object,
  validateForm: PropTypes.func,
  errors: PropTypes.object,
  validatedPasses: PropTypes.array,
  setFieldValue: PropTypes.func
};

export default ValidatePassNumber;
